import {Component, OnInit} from '@angular/core';
import {ContactNightKeyService} from "./contact-nightkey.service";

@Component({
  selector: 'app-contact-nightkey',
  templateUrl: './contact-nightkey.component.html',
  styleUrls: ['./contact-nightkey.component.less'],
  providers: [ContactNightKeyService]
})
export class ContactNightKeyComponent implements OnInit {

  nightkeyEmail: string;
  memberEmail: string;
  phone: string;

  buttonsEnabled = true;

  constructor(private contactService: ContactNightKeyService) {
  }

  ngOnInit() {

    this.getData()

  }

  cancel(){
   this.getData()
  }

  save() {
    this.buttonsEnabled = false;

    this.contactService.save({
      nightkeyEmail: this.nightkeyEmail,
      memberEmail: this.memberEmail,
      phone: this.phone
    }).subscribe(
      (r) => {
        this.nightkeyEmail = r.nightkeyEmail;
        this.memberEmail = r.memberEmail;
        this.phone = r.phone;

        this.buttonsEnabled = true;
      }
    );
  }

  getData(){
    this.buttonsEnabled = false;

    this.contactService.get().subscribe(
      (r) => {
        this.nightkeyEmail = r.nightkeyEmail;
        this.memberEmail = r.memberEmail;
        this.phone = r.phone;

        this.buttonsEnabled = true;
      }
    );
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/contact-nightkey/contact-nightkey.component.ts